<template>
	<div class="event-periods">
		<div class="row px-3">
			<div class="col-6 text-left">
				<a @click="resetMatchStats" class="btn btn-outline-danger" href="javascript:;">Sıfırla</a>
			</div>
			<div class="col-6 text-right">
				<a @click="saveMatchStats" class="btn btn-outline-success" href="javascript:;">Kaydet</a>
			</div>
		</div>
    <div class="row mt-4">
      <div class="col-2">
        <div class="element-box">
          Number of Periods: <input class="form-control number-input pull-right" type="number" v-model="numberOfPeriod"/>
        </div>
      </div>
      <div class="col-2">
        <div class="element-box">
          Period Type:
          <select class="pull-right form-control form-control-sm rounded w150 pull-right" v-model="periodType">
            <option :value="item" v-for="(item, index) in periodTypes" >{{ item }}</option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="element-box">
          Has Overtime:
          <input class="pull-right form-control" type="checkbox" v-model="overtime"/>
        </div>
      </div>
      <div class="col-2">
        <div class="element-box">
          Number of Extra Periods: <input class="form-control number-input pull-right" type="number" v-model="numberOfExtraPeriod"/>
        </div>
      </div>
      <div class="col-2">
        <div class="element-box">
          Extra Period Type:
          <select class="pull-right form-control form-control-sm rounded w150 pull-right" v-model="periodType">
            <option :value="item" v-for="(item, index) in periodTypes" >{{ item }}</option>
          </select>
        </div>
      </div>
    </div>
		<table class="table table-bordered table-lg table-v2 table-striped mt-2" v-for="(stat,key) in stats">
			<tbody>
			<tr>
				<td v-on:click="showMore">{{ key }}</td>
				<td width="120">
					<input v-model="stat.score.home" type="number" class="form-control text-right"/>
				</td>
				<td width="120">
					<input v-model="stat.score.away" type="number" class="form-control text-right"/>
				</td>
			</tr>
				<tr v-for="(s,key) in stat" v-if="show_more">
					<td class="text-left period-name">{{ key }}</td>
					<td width="120">
						<input v-model="s.home" type="number" class="form-control text-right"/>
					</td>
					<td width="120">
						<input v-model="s.away" type="number" class="form-control text-right"/>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
    export default {
      name: "periods",
	    props: ['event'],
	    data () {
			return {
          overtime: true,
          numberOfPeriod: 2,
          numberOfExtraPeriod: 0,
          periodType: 'period',
          periodTypes: [
              'period',
              'set',
              'half',
          ],
          extraPeriodTypes: [
              'period',
              'set',
              'half',
          ],
			    t: this.$root.t,
                stats: [],
				show_more: false
			}
	    },
	    mounted (){
            this.fetchStats();
	    },
        watch: {
            'event' (){
                this.fetchStats()
            },
            'periodType' () {
                this.fetchStats()
            },
            'numberOfPeriod' () {
                this.fetchStats()
            },
            'overtime' () {
                this.fetchStats()
            }
        },
	    methods: {
            showMore(){
                this.show_more = (this.show_more) ? false : true
            },
            fetchStats () {
                this.$http.get(bsapi+'api/v1/fixture/match_stat/'+this.event, {params: {numberOfPeriod: this.numberOfPeriod, periodType: this.periodType, overtime: this.overtime}}).then(response => {

                    this.stats = response.body.stats;
                }, response => {

                })
            },
		    saveMatchStats() {
                this.$http.post(bsapi+'api/v1/fixture/match_stat/save/'+this.event, {stat: this.stats}).then(response => {

                    swal('', this.t.processing.success, "success")
                }, response => {

                })
		    },
		    resetMatchStats() {
                this.$http.post(bsapi+'api/v1/fixture/match_stat/save/'+this.event, {stat: null}).then(response => {

                    swal('', this.t.processing.success, "success")
                    this.fetchStats()
                }, response => {

                })
		    }
	    }
    }
</script>

<style scoped>
  .event-periods {
    height: 60vh;
  }
  .number-input {
    width: 60px;
    height: 30px;
    margin: 0px;
    text-align: center;
  }
	.period-name{
		width: 300px
	}
	.btn-counter {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/stats/match/periods.vue